import React from 'react';
import { MessageSquare } from 'lucide-react';
import { trackEvent } from '../config/amplitude';

export const FeedbackWidget = () => {
  const handleOpenFeedback = () => {
    // Replace this URL with your Tally form URL
    window.open('https://tally.so/r/mOEgA8', '_blank');
    trackEvent('Feedback Form Opened');
  };

  return (
    <button
      onClick={handleOpenFeedback}
      className="fixed bottom-6 right-6 bg-sky-500 text-white p-3 rounded-full shadow-lg hover:bg-sky-600 transition-colors z-50"
      aria-label="Open feedback form"
    >
      <MessageSquare size={24} />
    </button>
  );
}; 